import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditClientAdditionalData = (props) => {
  const [aDTable, setADTable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [additionalData, setAdditionalData] = useState(
    props.mode === "add" ? props.additionalData : props.client.additionalData
  );

  const getADName = (name) => {
    if (additionalData === null) {
      return "";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === name.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) =>
            x.split(",")[0].replaceAll(" ", "") === name.replaceAll(" ", "")
        )[0]
        .split(",")[0];
    } else {
      return "";
    }
  };

  const getADPesel = (name) => {
    if (additionalData === null) {
      return "";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === name.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) =>
            x.split(",")[0].replaceAll(" ", "") === name.replaceAll(" ", "")
        )[0]
        .split(",")[1];
    } else {
      return "";
    }
  };

  const getADAddress = (name) => {
    if (additionalData === null) {
      return "";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === name.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) =>
            x.split(",")[0].replaceAll(" ", "") === name.replaceAll(" ", "")
        )[0]
        .split(",")[2];
    } else {
      return "";
    }
  };

  const getData = () => {
    setLoading(true);
    var arr = [];
    if (false) {
      var arr = additionalData.split("|");
      arr.pop();
      var arr2 = [];
      arr.map((el) => {
        var x = el.split(",");
        arr2.push({ name: x[0], pesel: x[1], address: x[2] });
      });
      setADTable(arr2);
    } else {
      props.client.petitioner.split(",").map((el) => {
        arr.push({
          name: getADName(el),
          pesel: getADPesel(el),
          address: getADAddress(el),
        });
      });
      setADTable(arr);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
    var arr = [];
  }, []);

  const editClient = async (e) => {
    var ret = "";
    aDTable.map((el) => {
      ret = ret + el.name + "," + el.pesel + "," + el.address + "|";
    });

    var test = true;

    aDTable.map((el) => {
      if (
        (el.pesel.length > 0 && el.pesel.length !== 11) ||
        (props.mode === "add" && el.pesel.length !== 11)
      ) {
        test = false;
      }
    });

    if (test) {
      setLoading(true);
      if (props.mode === "add") {
        props.setAdditionalData(ret);
        props.close();
      } else {
        var body = {
          id: props.client.id,
          value: ret,
        };

        await fetch("https://apidevkppp.ftpeople.pl/saveClientAD", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            props.logClientAction(
              "Edytowano informację o danych powodów",
              props.client.id
            );
            MySwal.fire({
              icon: "success",
              title: "Edytowano",
              text: "sprawę",
            }).then(async (result) => {
              props.close();
            });
          })
          .catch((error) => {});
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Nieprawidłowa",
        text: "ilośc znaków pola PESEL",
      }).then(async (result) => {});
    }
  };

  const clearClient = async (e) => {
    var ret = "";
    aDTable.map((el) => {
      ret = ret + el.name + "," + el.pesel + "," + el.address + "|";
    });

    setLoading(true);

    var body = {
      id: props.client.id,
      value: "",
    };

    await fetch("https://apidevkppp.ftpeople.pl/saveClientAD", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        props.logClientAction(
          "Edytowano informację o danych powodów",
          props.client.id
        );
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "sprawę",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const handlePeselChange = (e) => {
    var name = e.target.id;
    var arr = [];
    props.client.petitioner.split(",").map((el) => {
      arr.push({
        name: el,
        pesel: el === name ? e.target.value : getPesel(el),
        address: getAddress(el),
      });
    });
    setADTable(arr);
  };

  const handleAddressChange = (e) => {
    var name = e.target.id;
    var arr = [];
    props.client.petitioner.split(",").map((el) => {
      arr.push({
        name: el,
        pesel: getPesel(el),
        address:
          el === name ? e.target.value.replaceAll(",", ";") : getAddress(el),
      });
    });
    setADTable(arr);
  };

  const getPesel = (name) => {
    var pesel = "";
    aDTable.map((el) => {
      if (el.name.replaceAll(" ", "") === name.replaceAll(" ", "")) {
        pesel = el.pesel;
      }
    });
    return pesel;
  };

  const getAddress = (name) => {
    var address = "";
    aDTable.map((el) => {
      if (el.name.replaceAll(" ", "") === name.replaceAll(" ", "")) {
        address = el.address;
      }
    });
    return address;
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div style={{ width: "30vw" }} className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div style={{ maxHeight: "50vh", overflowY: "scroll" }}>
            {props.client.petitioner.split(",").map((el) => (
              <>
                <div>
                  <p>{el}</p>
                  <div style={{ width: "80%" }}>
                    <label>PESEL</label>
                    <input
                      type="text"
                      id={el}
                      name="name"
                      value={getPesel(el)}
                      onChange={handlePeselChange}
                      onKeyPress={checkDigit}
                    />
                  </div>
                  <div style={{ width: "80%", marginTop: "2vh" }}>
                    <label>ADRES</label>
                    <input
                      type="text"
                      id={el}
                      name="name"
                      value={getAddress(el)}
                      onChange={handleAddressChange}
                    />
                  </div>
                </div>
              </>
            ))}
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
            {props.mode !== "add" ? (
              <>
                {" "}
                <button
                  style={{ marginLeft: "20px" }}
                  className="paymentMenuButton"
                  onClick={clearClient}
                >
                  wyczyść
                </button>
              </>
            ) : (
              ""
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default EditClientAdditionalData;
